<template>
    <div class="fullscreen">
        <!-- <svg id="loading-image" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
            <g>
                <path
                    class="cls-1"
                    d="M113.93,9.42,31.76,34.67a2.62,2.62,0,0,0-1,4.47l18,15.73a1.35,1.35,0,0,1,.47,1.06L48.87,89a1.23,1.23,0,0,0,2.18.79L66.4,71.69a1.06,1.06,0,0,1,1.49-.11L92,92.62a2.4,2.4,0,0,0,3.9-1.2l21-79.24A2.27,2.27,0,0,0,113.93,9.42ZM113,14,65.49,68.34a2.08,2.08,0,0,1-3,.26L50.91,56.85a1.86,1.86,0,0,1,.19-3l61.37-40.43A.39.39,0,0,1,113,14Z"
                />
                <animateMotion
                    dur="2s"
                    repeatCount="indefinite"
                    path="M0, 0
                        C0, -1
                        1, -1
                        -15, -5
                        C1-20
                        1, 5
                        2, -10 z"
                />
            </g>
            <g>
                <g>
                    <line class="cls-2" x1="43.2" y1="62.91" x2="30.81" y2="75.3" />
                    <animateMotion
                        dur="2s"
                        repeatCount="indefinite"
                        path="M0, 0
                                C0, 0                        1, -1
                                -5, -5
                                C1-30
                                1, 5
                                2, -10 z"
                    />
                </g>
                <g>
                    <line class="cls-2" x1="43.2" y1="90.58" x2="26.48" y2="107.31" />
                    <animateMotion
                        dur="2s"
                        repeatCount="indefinite"
                        path="M0, 0
                                C0, -1
                                12, -4
                                -15, -5
                                C3-30
                                11, -15
                                2, -15 z"
                    />
                </g>
                <g>
                    <line class="cls-2" x1="74.23" y1="98.94" x2="62.26" y2="110.35" />
                    <animateMotion
                        dur="2s"
                        repeatCount="indefinite"
                        path="M0, 0
                                C0, -2
                                1, -1
                                -5, 15
                                C2-10
                                15, 5
                                2, -5 z"
                    />
                </g>
                <g>
                    <line class="cls-2" x1="71.94" y1="79.44" x2="64" y2="87.37" />
                    <animateMotion
                        dur="2s"
                        repeatCount="indefinite"
                        path="M0, 0
                                C0, -5
                                -1, -1
                                1, 10
                                C1-10
                                1, 5
                                1, -10 z"
                    />
                </g>
                <animateMotion
                    dur="2s"
                    repeatCount="indefinite"
                    path="M0, 0
                            C0, -1
                            1, -1
                            -15, -5
                            C1-20
                            1, 5
                            2, -10 z"
                />
            </g>
        </svg> -->
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>

<style scoped>
.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fffd;
    display: flex;
    justify-content: center;
    align-items: center;
}
#loading-image {
    width: 64px;
    height: 64px;
}
.cls-1 {
    fill: #8b41fa;
}
.cls-2 {
    fill: none;
    stroke: #8b41fa;
    stroke-linecap: round;
    stroke-linejoin: round;
}

.lds-ring,
.lds-ring div {
    box-sizing: border-box;
    color: #8b41fa;
}
.lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid currentColor;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
